/* /assets/section-help-center.js */

class HelpCenter {
  constructor(section) {
    this.section = section;
    this.navigation = section.querySelector('[data-help-navigation]');
    this.content = section.querySelector('[data-help-content]');

    if (!this.navigation || !this.content) return;

    this.buildNavigation();

    this.triggers = Array.from(
      this.navigation.querySelectorAll('[data-help-trigger]')
    );

    this.panels = Array.from(
      this.content.querySelectorAll('[data-help-panel]')
    );

    if (!this.triggers.length || !this.panels.length) return;

    this.bindEvents();
    this.loadInitialCategory();

    this.section.classList.add('is-initialized');
  }


  buildNavigation() {
    const triggers = Array.from(
      this.content.querySelectorAll(
        '.help-center__category > [data-help-trigger]'
      )
    );

    triggers.forEach((trigger) => {
      this.navigation.appendChild(trigger);
    });
  }


  bindEvents() {
    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {

        const uid = trigger.dataset.helpTrigger;
        const slug = trigger.dataset.helpSlug;

        this.activate(uid, slug, true);

      });
    });


    this.handleHistory = () => {
      const slug = this.getSlugFromHash();

      if (slug) {
        const trigger = this.triggers.find(
          item => item.dataset.helpSlug === slug
        );

        if (trigger) {
          this.activate(
            trigger.dataset.helpTrigger,
            trigger.dataset.helpSlug,
            false
          );

          return;
        }
      }

      this.activateFirst();
    };


    window.addEventListener(
      'hashchange',
      this.handleHistory
    );

    window.addEventListener(
      'popstate',
      this.handleHistory
    );
  }


  activate(uid, slug, updateUrl = true) {
    const trigger = this.triggers.find(
      item => item.dataset.helpTrigger === uid
    );

    const panel = this.panels.find(
      item => item.dataset.helpPanel === uid
    );

    if (!trigger || !panel) return;


    this.triggers.forEach((item) => {
      item.classList.remove('is-selected');
      item.setAttribute('aria-selected', 'false');
    });


    this.panels.forEach((item) => {
      item.classList.remove('is-active');
    });


    trigger.classList.add('is-selected');
    trigger.setAttribute('aria-selected', 'true');

    panel.classList.add('is-active');


    if (updateUrl && slug) {
      this.updateHash(slug);
    }
  }


  activateFirst() {
    if (!this.triggers.length) return;

    const first = this.triggers[0];

    this.activate(
      first.dataset.helpTrigger,
      first.dataset.helpSlug,
      false
    );
  }


  getSlugFromHash() {
    const hash = window.location.hash.replace(/^#/, '');

    if (!hash) return null;

    const params = new URLSearchParams(hash);

    return params.get('selected');
  }


  updateHash(slug) {
    const hash =
      'selected=' +
      encodeURIComponent(slug);

    const url =
      window.location.pathname +
      window.location.search +
      '#' +
      hash;

    if (window.history && window.history.pushState) {
      window.history.pushState(
        { helpCategory: slug },
        '',
        url
      );
    } else {
      window.location.hash = hash;
    }
  }


  loadInitialCategory() {
    const slug = this.getSlugFromHash();

    if (slug) {
      const trigger = this.triggers.find(
        item => item.dataset.helpSlug === slug
      );

      if (trigger) {
        this.activate(
          trigger.dataset.helpTrigger,
          trigger.dataset.helpSlug,
          false
        );

        return;
      }
    }

    this.activateFirst();
  }
}


function initializeHelpCenters(container = document) {
  let sections = [];

  if (
    container.matches &&
    container.matches('[data-help-center]')
  ) {
    sections.push(container);
  }

  if (container.querySelectorAll) {
    sections = sections.concat(
      Array.from(
        container.querySelectorAll('[data-help-center]')
      )
    );
  }

  sections.forEach((section) => {
    if (section.dataset.helpInitialized === 'true') return;

    section.dataset.helpInitialized = 'true';

    new HelpCenter(section);
  });
}


if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    () => initializeHelpCenters()
  );
} else {
  initializeHelpCenters();
}


document.addEventListener(
  'shopify:section:load',
  (event) => {
    initializeHelpCenters(event.target);
  }
);